import React, { useState, useRef, useEffect } from "react";

import "../chatbubble/chatbubble.css";


const ChatBubble = ({ message, isSender, time }) => {
  return (
    <div className={`chat-bubble ${isSender ? "sender" : "receiver"}`}>
      <p>{message}</p>
      <span className="time">{time}</span>
    </div>
  );
};

export default ChatBubble;
